import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useBooking } from "../context/BookingContext";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useBooking();
  const [mode, setMode] = useState("login"); // login | signup
  const [form, setForm] = useState({ name: "", phone: "", otp: "" });
  const [step, setStep] = useState(1); // 1 = phone, 2 = otp
  const [error, setError] = useState("");

  const handleSendOTP = (e) => {
    e.preventDefault();
    if (!/^[6-9]\d{9}$/.test(form.phone)) { setError("Enter a valid 10-digit phone number"); return; }
    setError("");
    setStep(2);
  };

  const handleVerify = (e) => {
    e.preventDefault();
    if (form.otp !== "1234") { setError("Invalid OTP. Use 1234 for demo."); return; }
    setError("");
    setUser({ name: form.name || "Player", phone: form.phone });
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen pt-16 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-gold-500 rounded-2xl flex items-center justify-center text-2xl mx-auto mb-4">🏏</div>
            <h1 className="font-display text-2xl font-bold text-white">
              {mode === "login" ? "Welcome Back" : "Create Account"}
            </h1>
            <p className="text-white/40 text-sm mt-1">
              {mode === "login" ? "Sign in to manage your bookings" : "Join thousands of cricket lovers"}
            </p>
          </div>

          <div className="card-dark p-6">
            {step === 1 ? (
              <form onSubmit={handleSendOTP} className="space-y-4">
                {mode === "signup" && (
                  <div>
                    <label className="block text-white/60 text-sm mb-1.5">Full Name</label>
                    <input
                      type="text"
                      placeholder="Virat Kohli"
                      className="input-field"
                      value={form.name}
                      onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                    />
                  </div>
                )}
                <div>
                  <label className="block text-white/60 text-sm mb-1.5">Phone Number</label>
                  <div className="flex gap-2">
                    <div className="bg-dark-700 border border-white/10 rounded-xl px-3 py-3 text-white/50 text-sm font-medium flex-shrink-0">+91</div>
                    <input
                      type="tel"
                      placeholder="9876543210"
                      className="input-field flex-1"
                      maxLength={10}
                      value={form.phone}
                      onChange={(e) => { setForm((f) => ({ ...f, phone: e.target.value })); setError(""); }}
                    />
                  </div>
                </div>
                {error && <p className="text-red-400 text-xs">{error}</p>}
                <button type="submit" className="btn-gold w-full py-3.5">Send OTP →</button>
              </form>
            ) : (
              <form onSubmit={handleVerify} className="space-y-4">
                <p className="text-white/50 text-sm">OTP sent to +91 {form.phone}. <button type="button" onClick={() => setStep(1)} className="text-gold-400 hover:underline">Change</button></p>
                <div>
                  <label className="block text-white/60 text-sm mb-1.5">Enter OTP</label>
                  <input
                    type="text"
                    placeholder="1234 (demo)"
                    className="input-field text-center text-2xl tracking-[0.5em] font-bold"
                    maxLength={4}
                    value={form.otp}
                    onChange={(e) => { setForm((f) => ({ ...f, otp: e.target.value })); setError(""); }}
                  />
                </div>
                {error && <p className="text-red-400 text-xs">{error}</p>}
                <button type="submit" className="btn-gold w-full py-3.5">Verify & Sign In →</button>
                <p className="text-white/30 text-xs text-center">Use <strong className="text-white/50">1234</strong> as OTP for demo</p>
              </form>
            )}

            <div className="border-t border-white/5 mt-5 pt-5 text-center">
              <p className="text-white/40 text-sm">
                {mode === "login" ? "New here?" : "Already have an account?"}{" "}
                <button
                  onClick={() => { setMode(mode === "login" ? "signup" : "login"); setStep(1); setError(""); }}
                  className="text-gold-400 font-medium hover:underline"
                >
                  {mode === "login" ? "Create Account" : "Sign In"}
                </button>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
